import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import {
  Grid,
  Backdrop,
  CircularProgress,
  Typography,
  Card,
  CardContent,
  Paper,
  Box,
} from "@mui/material";
import ScrollableCardPhone from "./ScrollableCardPhone";
// CSS

import TaskRoundedIcon from "@mui/icons-material/TaskRounded";
import AssignmentTurnedInRoundedIcon from "@mui/icons-material/AssignmentTurnedInRounded";
import { useSwipeable } from "react-swipeable";
import "../../App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./edit_phone_v2.css";
// component
import Header_Home from "../Component/Header_Home";
import Header from "../Component/Header";
import PopUp from "../Component/Popup";
import { CustomCarousel } from "../Component/CustomCarousel";
import { CustomInputText } from "../Component/CustomInputText";

import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";
// services
import {
  getPersonalPhoneAPI,
  getUserProfileAPI,
  updatePersonalPhoneAPI,
  getPersonalPhoneNewAPI,
} from "./PersonalService/personalService";
// icon
import icon_smartphone_call from "../../Icon/smartphone-call.png";
import Modal from "react-modal";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import iconSearch from "../../images/icon-search-2.png";
import ArrowCircleLeftOutlinedIcon from "@mui/icons-material/ArrowCircleLeftOutlined";
import Skeleton from "react-loading-skeleton";
import { Modal as BootstrapModal } from "react-bootstrap";
import greenCheck from "../../Icon/green-circle-check.png";
import remove from "../../images/remove.png";
import MultipleSelectPhone from "./MultipleSelectPhone";
import { CardHeader } from "@mui/material";
import { getPolicyInformationAPI } from "../PolicyList/PolicyListService/policyListService";
import CryptoJS from "crypto-js";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import { requestOtpAPI } from "../changePay/changePayService/changePayService";
import { toast, ToastContainer } from "react-toastify";
import ContactModal from "../Component/ContactModal";

const EditPhone2 = (props) => {
  let navigate = useNavigate();

  const refCarousel = useRef(null);

  const [phoneStep, setPhoneStep] = useState(1);
  const [phoneData, setPhoneData] = useState([]);
  const [selectedPhone, setSelectedPhone] = useState([]);
  const [loading, setLoading] = useState(true); // for get profile, get phone, save edit phone
  const [option, setOption] = useState([]);

  const [mobilePhone, setMobilePhone] = useState();
  const [homePhone, setHomePhone] = useState();
  const [workPhone, setWorkPhone] = useState();
  const [homePhoneTo, setHomePhoneTo] = useState();
  const [workPhoneTo, setWorkPhoneTo] = useState();
  const [otherPhone, setOtherPhone] = useState();
  const [inputErrors, setInputErrors] = useState([]);
  const breakPoints = [{ width: 1, itemsToShow: 1 }];
  const [activeIndex, setActiveIndex] = useState(0);
  const [clickPre, setClickPre] = useState();
  const [clickForward, setClickForward] = useState();
  const [currentItem, setCurrentItem] = useState(0);
  const [totalItem, setTotalItem] = useState(0);
  const [openModal, setOpenModal] = useState(false);
  const handleOpenModal = () => setOpenModal(true);
  const [searchBasePolicy, setSearchBasePolicy] = useState("");
  const [activeDataModal, setActiveDataModal] = useState(0);
  const [completedModal, setCompletedModal] = useState(false);
  const [textModal, setTextModal] = useState("");
  const [toggleImg, setToggleImg] = useState(false);

  const [selectedIndexes, setSelectedIndexes] = useState([]); // เก็บ index ของ Box ที่ถูกเลือกเป็น array
  const [isChecked, setIsChecked] = useState(false); // สถานะของ CheckAll
  const [listData, setListData] = useState([]); // เก็บข้อมูลที่ถูกเลือก

  const [inputData, setInputData] = useState([{}]);
  const [insureIdCard, setInsureIdCard] = useState(
    localStorage.getItem("customer_id")
  );
  const [dataPolicy, setDataPolicy] = useState([]);
  const [otp, setOtp] = useState("");
  const [openContactModal, setOpenContactModal] = useState(false);

  const handleInputDataChange = (data) => {
    setInputData(data);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setSearchBasePolicy("");
  };

  const handleSelectSearch = (idx) => {
    setActiveDataModal(idx);
  };
  // ----- function for Step 1 update phone -----
  const getPersonalPhone = () => {
    setLoading(true);
    // setErrorPhoneData(false);
    getPersonalPhoneAPI()
      .then((res) => {
        setLoading(false);
        if (res.success) {
          let option = [];

          res.payload.map((item, idx) => {
            let dataTmp = {
              label: item.policy_no,
              id: idx,
            };
            option.push(dataTmp);
          });
          setOption(option);
          setPhoneData(res.payload);
        }
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
        setToggleImg(false);
        setTextModal("ไม่สามารถเข้าถึงข้อมูลได้");
        setCompletedModal(true);
      });
  };

  const isEmptyObject = (obj) => {
    return obj && Object.keys(obj).length === 0 && obj.constructor === Object;
  };

  const validatePhone = () => {
    // console.log("dsfsdfsd");
    // console.log(inputData.mobile);
    let error = false;

    // ฟังก์ชันตรวจสอบความถูกต้องของหมายเลขโทรศัพท์มือถือในประเทศไทย (ขึ้นต้นด้วย 0 และมี 10 หลัก)
    const validateMobileNumber = (number) => {
      const mobilePattern = /^0[689]\d{8}$/; // รูปแบบเบอร์มือถือที่ถูกต้องในไทย
      return mobilePattern.test(number);
    };

    // ฟังก์ชันตรวจสอบหมายเลขโทรศัพท์บ้าน (ควรขึ้นต้นด้วยรหัสจังหวัดและมีตัวเลขรวม 9 หลัก)
    const validateHomeNumber = (number) => {
      const homePattern = /^(02|0[3-9]\d)\d{7}$/; // รูปแบบเบอร์โทรศัพท์บ้านของไทย
      return homePattern.test(number);
    };

    // ตรวจสอบว่า inputData ไม่ควรเป็นว่างเปล่า
    if (isEmptyObject(inputData)) {
      error = true;
      setToggleImg(false);
      setTextModal("กรุณาเลือกประเภทโทรศัพท์ที่ท่านต้องการเปลี่ยน");
      setCompletedModal(true);
    } else {
      // ตรวจสอบเบอร์มือถือ
      if (inputData.mobile != undefined) {
        if (inputData.mobile == "") {
          if (inputData.mobile == "") {
            setToggleImg(false);
            setTextModal("กรุณาระบุเบอร์โทรศัพท์มือถือ");
            setCompletedModal(true);
            error = true;
          }
        } else {
          if (!validateMobileNumber(inputData.mobile)) {
            setToggleImg(false);
            setTextModal("เบอร์โทรศัพท์มือถือไม่ถูกต้อง");
            setCompletedModal(true);
            error = true;
          }
        }
      }

      // ตรวจสอบเบอร์โทรศัพท์บ้าน
      if (inputData.phone_home) {
        if (inputData.phone_home[0] == "") {
          setToggleImg(false);
          setTextModal("กรุณาระบุเบอร์บ้าน");
          setCompletedModal(true);
          error = true;
        } else if (!validateHomeNumber(inputData.phone_home[0])) {
          setToggleImg(false);
          setTextModal("เบอร์โทรศัพท์บ้านไม่ถูกต้อง");
          setCompletedModal(true);
          error = true;
        }
      }

      // ตรวจสอบเบอร์โทรศัพท์บ้าน
      if (inputData.phone_office) {
        if (inputData.phone_office[0] == "") {
          setToggleImg(false);
          setTextModal("กรุณาระบุเบอร์โทรศัพท์ที่ทำงาน");
          setCompletedModal(true);
          error = true;
        }
        //  else if (!validateHomeNumber(inputData.phone_office[0])) {
        //   setToggleImg(false);
        //   setTextModal("เบอร์โทรศัพท์ที่ทำงานไม่ถูกต้อง");
        //   setCompletedModal(true);
        //   error = true;
        // }
      }

      if (inputData.phone_other != undefined) {
        if (inputData.phone_other == "") {
          if (inputData.phone_other == "") {
            setToggleImg(false);
            setTextModal("กรุณาระบุเบอร์โทรศัพท์อื่นๆ");
            setCompletedModal(true);
            error = true;
          }
        }
        // else{
        //   if (!validateMobileNumber(inputData.phone_other)) {
        //     setToggleImg(false);
        //     setTextModal("เบอร์โทรศัพท์อื่นๆไม่ถูกต้อง");
        //     setCompletedModal(true);
        //     error = true;
        //   }
        // }
      }
    }

    // ตรวจสอบว่า listData ต้องมีอย่างน้อย 1 รายการ
    if (listData.length === 0) {
      error = true;
      setToggleImg(false);
      setTextModal("กรุณาเลือกกรมธรรม์อย่างน้อย 1 รายการ");
      setCompletedModal(true);
    }

    return error;
  };

  const removeInputError = (inputId) => {
    setInputErrors((errors) => errors.filter((err) => err !== inputId));
  };

  const savePhone = () => {
    setLoading(true);
    // setErrorSavePhoneData(false);
    // console.log(listData);
    // const errorsPhone = validatePhone();
    if (selectedPhone.length > 0) {
      const payload = { policies: [] };
      listData.forEach((item) => {
        payload.policies.push({
          policy_no: item.policy_no.trim(),
          policy_number: item.id,
          mobile: item.mobile !== undefined ? item.mobile : "",
          phone_home:
            inputData.phone_home !== undefined ? inputData.phone_home[0] : "",
          phone_office:
            inputData.phone_office !== undefined
              ? inputData.phone_office[0]
              : "",
          phone_home_to:
            inputData.phone_home !== undefined ? inputData.phone_home[1] : "",
          phone_office_to:
            inputData.phone_office !== undefined
              ? inputData.phone_office[1]
              : "",
          phone_other:
            inputData.phone_other !== undefined ? inputData.phone_other : "",

          old_mobile: item.old_mobile,
          old_phone_office: item.old_phone_office,
          old_phone_home: item.old_phone_home,
          old_phone_office_to: item.old_phone_office_to,
          old_phone_home_to: item.old_phone_home_to,
          old_phone_other: item.old_phone_other,
          otp: otp,
          userName: decryptCardNumber(
            insureIdCard,
            process.env.REACT_APP_ENCRYPT_DATA
          ),
        });
      });
      // console.log("payload to submit >>>", payload);
      updatePersonalPhoneAPI(payload)
        .then((res) => {
          setLoading(false);
          if (res.success) {
            setToggleImg(true);
            setTextModal("บริษัทได้รับทราบข้อมูลจากท่านแล้ว \nขอบคุณค่ะ");
            setCompletedModal(true);
          } else {
            console.error("fail Save Phone Data", res);
            // setErrorSavePhoneData(true);
            // setOpenErrorSavePhone(true);
            setToggleImg(false);
            setTextModal(res.payload.error);
            setCompletedModal(true);
          }
        })
        .catch((err) => {
          console.error(err);
          setLoading(false);
          // setErrorSavePhoneData(true);
          // setOpenErrorSavePhone(true);
          setToggleImg(false);
          setTextModal("ไม่สามารถบันทึกข้อมูลได้");
          setCompletedModal(true);
        });
    }
  };

  const filteredOptions = option.filter((item) => {
    return searchBasePolicy.trim() === ""
      ? true
      : item.label.toLowerCase().includes(searchBasePolicy.toLowerCase());
  });

  const renderOptionRow = (val, idx) => {
    const isActive = activeDataModal === idx;

    return (
      <div key={idx}>
        <Row
          onClick={!isActive ? () => handleSelectSearch(idx) : undefined}
          style={isActive ? { backgroundColor: "#FF5E43" } : {}}
          className={`gap-1 border-top border-bottom border-1 rounded-1 ${
            isActive ? "text-white" : "text-danger pointer"
          }`}
        >
          <Col className="px-3 d-flex flex-row justify-content-between">
            <span>{val.label}</span>
            {isActive && (
              <ArrowCircleLeftOutlinedIcon style={{ color: "white" }} />
            )}
          </Col>
        </Row>
      </div>
    );
  };

  useEffect(() => {
    const updatedList = listData.map((item) => ({
      ...item,
      policy_no: item.policy_no,
      mobile: inputData.mobile ?? "",
      phone_home: inputData.phone_home?.[0] ?? "",
      phone_office: inputData.phone_office?.[0] ?? "",
      phone_home_to: inputData.phone_home?.[1] ?? "",
      phone_office_to: inputData.phone_office?.[1] ?? "",
      phone_other: inputData.phone_other ?? "",
    }));
    // console.log("updatedList:", updatedList);
    setListData(updatedList);
  }, [inputData]);

  useEffect(() => {
    // check user profile

    setLoading(true);
    getUserProfileAPI()
      .then((res) => {
        setLoading(false);
        if (res.success == "true") {
          if (res.payload.profile == "POS2") {
            // window.location.href = "/home";
            navigate("/home");
          }
        }
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
        // setErrorProfileData(true);
        // setOpenErrorWarning(true);
        // alert("ไม่สามารถเข้าถึงข้อมูลได้");
        setToggleImg(false);
        setTextModal("ไม่สามารถเข้าถึงข้อมูลได้");
        setCompletedModal(true);
      });
    // get Personal Phone
    getPersonalPhone();

    return () => {
      // console.log("useEffect return unmount >>>");
    };
  }, []);

  const handleConfrimSearch = () => {
    // console.log("activeDataModal", activeDataModal);
    setActiveIndex(activeDataModal);
    // updateDataPolicyActive(activeDataModal);
    handleCloseModal();
    setUpSelectPhone(activeDataModal);
  };

  const handleSearchBasePolicy = (e) => {
    setSearchBasePolicy(e);
  };

  const setUpSelectPhone = (index) => {
    setSelectedPhone((prev) => {
      let findPhone = prev.find((i) => i.id === phoneData[index].id);
      if (findPhone) {
        return prev.filter((ii) => ii.id !== findPhone.id);
      } else {
        // return [...prev, phoneData[index]]; // multi
        return [phoneData[index]];
      }
    });
  };

  const handleOwlChange = async (e) => {
    setActiveIndex(e);
    setActiveDataModal(e);
    setUpSelectPhone(e);
    // updateDataPolicyActive(e);
  };

  useEffect(() => {
    // console.log(phoneData);
    if (phoneData.length > 0) {
      setUpSelectPhone(0);
    }
  }, [phoneData]);

  const styleDrive = {
    py: 0,
    width: "100%",
    maxWidth: "auto",
    // borderRadius: 2,
    // border: '1px solid',
    borderColor: "divider",
    backgroundColor: "background.paper",
  };

  const ScrollableCardInformation = () => {
    const cardRef = React.useRef(null);

    const handlers = useSwipeable({
      onSwiped: (eventData) => {
        if (cardRef.current) {
          cardRef.current.scrollTop += -eventData.deltaY; // เลื่อนการ์ดตามการสไวป์ (ขึ้นหรือลง)
        }
      },
      delta: 10, // กำหนดความไวต่อการสไวป์
      trackMouse: true, // ทำให้ใช้เมาส์ในการลากได้
    });

    return (
      <Card
        sx={{
          maxHeight: "510px",
          overflowY: "hidden",
          border: "1px solid rgba(255, 94, 67, 0.3) ", // สีของขอบ #FF5E43 ที่โปร่งใส 30%
          borderRadius: "12px", // ความโค้งของขอบ
          borderWidth: "2px",
          display: "flex",
          flexDirection: "column",
          boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
        }}
        ref={cardRef}
        {...handlers} // ผูกฟังก์ชันสไวป์ให้กับการ์ด
      >
        <CardContent
          sx={{
            cursor: "pointer",
            overflowY: "auto", // เปิดการเลื่อนในแนวตั้ง
            boxSizing: "border-box",
          }}
        >
          <List sx={styleDrive} style={{ marginBottom: "30px" }}>
            <ListItem>
              <ListItemText primary="กรุณาตรวจสอบข้อมูล" />
            </ListItem>
            <Divider variant="middle" component="li" />
          </List>
          {listData.map((item, index) => {
            // แสดงผลหมายเลขโทรศัพท์มือถือ
            const mobileDisplay = item.mobile || "-";

            // แสดงผลหมายเลขโทรศัพท์บ้าน
            const phoneHomeDisplay =
              item.phone_home && item.phone_home !== "-" ? item.phone_home : "";
            const phoneHomeToDisplay =
              item.phone_home_to && item.phone_home_to !== "-"
                ? `ต่อ ${item.phone_home_to}`
                : "";
            const phoneHomeFinal =
              phoneHomeDisplay || phoneHomeToDisplay
                ? `${phoneHomeDisplay} ${phoneHomeToDisplay}`
                : "-";

            // แสดงผลหมายเลขโทรศัพท์ที่ทำงาน
            const phoneOfficeDisplay = item.phone_office || "";
            const phoneOfficeToDisplay = item.phone_office_to
              ? `ต่อ ${item.phone_office_to}`
              : "";
            const phoneOfficeFinal =
              phoneOfficeDisplay || phoneOfficeToDisplay
                ? `${phoneOfficeDisplay} ${phoneOfficeToDisplay}`
                : "-";

            // แสดงผลหมายเลขโทรศัพท์อื่นๆ
            const phoneOtherDisplay = item.phone_other || "-";

            // แสดงผลหมายเลขโทรศัพท์เก่า
            const oldMobileDisplay = item.old_mobile || "-";
            const oldPhoneHomeDisplay =
              item.old_phone_home && item.old_phone_home !== "-"
                ? item.old_phone_home
                : "";
            const oldPhoneHomeToDisplay =
              item.old_phone_home_to && item.old_phone_home_to !== "-"
                ? `ต่อ ${item.old_phone_home_to}`
                : "";
            const oldPhoneHomeFinal =
              oldPhoneHomeDisplay || oldPhoneHomeToDisplay
                ? `${oldPhoneHomeDisplay} ${oldPhoneHomeToDisplay}`
                : "-";

            const oldPhoneOfficeDisplay =
              item.old_phone_office && item.old_phone_office !== "-"
                ? item.old_phone_office
                : "";
            const oldPhoneOfficeToDisplay =
              item.old_phone_office_to && item.old_phone_office_to !== "-"
                ? `ต่อ ${item.old_phone_office_to}`
                : "";
            const oldPhoneOfficeFinal =
              oldPhoneOfficeDisplay || oldPhoneOfficeToDisplay
                ? `${oldPhoneOfficeDisplay} ${oldPhoneOfficeToDisplay}`
                : "-";

            const oldPhoneOtherDisplay = item.old_phone_other || "-";

            return (
              <Box
                key={index}
                sx={{
                  marginBottom: "15px",
                  padding: "10px",
                  transition: "background-color 0.3s ease, border 0.3s ease",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Card>
                  <CardHeader
                    title={`กรมธรรม์เลขที่ : ${item.policy_no}`}
                    sx={{ backgroundColor: "rgba(255, 94, 67, 0.3)" }}
                    titleTypographyProps={{
                      sx: {
                        fontFamily: '"Prompt-Thin", sans-serif !important',
                        fontSize: "15px",
                        color: "black",
                        marginLeft: "15px",
                      },
                    }}
                  />
                  <CardContent>
                    {/* <List sx={styleDrive} style={{ marginBottom: "10px" }}>
                      <ListItem>
                        <ListItemText primary="ข้อมูลใหม่" />
                      </ListItem>
                      <Divider variant="middle" component="li" />
                    </List> */}

                    <Typography>
                      <Grid container spacing={1}>
                        <Grid item xs={7} sm={4} md={2} lg={3} xl={3}>
                          <span className="font-size-label-pol">
                            เบอร์โทรศัพท์มือถือ :
                          </span>
                        </Grid>
                        <Grid item xs={5} sm={5} md={2} lg={2} xl={2}>
                          <span className="font-size-label-pol">
                            {mobileDisplay}
                          </span>
                        </Grid>
                      </Grid>

                      <Grid container spacing={1}>
                        <Grid item xs={7} sm={7} md={2} lg={3} xl={3}>
                          <span className="font-size-label-pol">
                            เบอร์โทรศัพท์บ้าน :
                          </span>
                        </Grid>
                        <Grid item xs={5} sm={5} md={2} lg={8} xl={8}>
                          <span className="font-size-label-pol">
                            {phoneHomeFinal}
                          </span>
                        </Grid>
                      </Grid>

                      <Grid container spacing={1}>
                        <Grid item xs={7} sm={7} md={4} lg={3} xl={3}>
                          <span className="font-size-label-pol">
                            เบอร์โทรศัพท์ที่ทำงาน :
                          </span>
                        </Grid>
                        <Grid item xs={5} sm={5} md={2} lg={7} xl={9}>
                          <span className="font-size-label-pol">
                            {phoneOfficeFinal}
                          </span>
                        </Grid>
                      </Grid>

                      <Grid container spacing={1}>
                        <Grid item xs={7} sm={4} md={2} lg={3} xl={3}>
                          <span className="font-size-label-pol">
                            เบอร์โทรศัพท์อื่นๆ :
                          </span>
                        </Grid>
                        <Grid item xs={5} sm={5} md={2} lg={2} xl={2}>
                          <span className="font-size-label-pol">
                            {phoneOtherDisplay}
                          </span>
                        </Grid>
                      </Grid>
                    </Typography>
                  </CardContent>
                </Card>
              </Box>
            );
          })}
        </CardContent>
      </Card>
    );
  };
  useEffect(() => {
    getPolicyInformation();
    // getPersonalPhoneNew()
  }, []);

  const decryptCardNumber = (encryptedCardNumber, secretKey) => {
    const bytes = CryptoJS.AES.decrypt(encryptedCardNumber, secretKey);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);
    return decrypted;
  };

  const getPolicyInformation = async () => {
    const result = await getPolicyInformationAPI(
      decryptCardNumber(insureIdCard, process.env.REACT_APP_ENCRYPT_DATA)
    );
    if (result.status) {
      let option = [];
      await result.data.policies.map((item, idx) => {
        let data = {
          label: item.policyNo,
          id: idx,
        };
        option.push(data);
      });

      setDataPolicy(result.data.policies);
      await setOption(option);
    }
  };

  const resendOtp = () => {
    handleReqOtp();
  };

  const notifySuccess = (title) => {
    toast.success(title, {
      position: "top-center",
    });
  };

  const notifyError = (title) => {
    toast.error(title, {
      position: "top-center",
    });
  };

  const handleReqOtp = async () => {
    const resultReqOtp = await requestOtpAPI("EDIT_PHONE");
    if (resultReqOtp.status === true) {
      notifySuccess(resultReqOtp.meg);
    } else {
      notifyError(resultReqOtp.meg);
    }
  };

  // const getPersonalPhoneNew = () => {
  //   setLoading(true);
  //   // setErrorPhoneData(false);
  //   getPersonalPhoneNewAPI()
  //     .then((res) => {
  //       setLoading(false);
  //       if (res.success) {
  //         let option = [];

  //         res.payload.map((item, idx) => {
  //           let dataTmp = {
  //             label: item.policy_no,
  //             id: idx,
  //           };
  //           option.push(dataTmp);
  //         });
  //         setOption(option);
  //         setPhoneData(res.payload);
  //         console.log(res.payload);
  //       }
  //     })
  //     .catch((err) => {
  //       console.error(err);
  //       setLoading(false);
  //       setToggleImg(false);
  //       setTextModal("ไม่สามารถเข้าถึงข้อมูลได้");
  //       setCompletedModal(true);
  //     });
  // };

  return (
    <div className="edit-phone">
      {loading ? (
        <Backdrop
          sx={{
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={loading}
        >
          <CircularProgress
            sx={{
              animationDuration: "550ms",
            }}
            color="inherit"
          />
        </Backdrop>
      ) : null}
      <Header_Home />
      <Header title="เปลี่ยนเบอร์โทรศัพท์" />
      <div className="container-footer-space">
        <section
          className="update-receiving-address"
          style={{ display: phoneStep === 1 ? "block" : "none" }}
        >
          <div className="pb-2">
            <img
              className="address-icon"
              src={icon_smartphone_call}
              alt="phone-icon"
            />
            <span className="bold">{"เบอร์โทรศัพท์"}</span>
          </div>
          <div className="px-4">
            <MultipleSelectPhone onInputChange={handleInputDataChange} />
          </div>
        </section>
        <br />

        <Box
          sx={{
            display: phoneStep === 2 ? "flex" : "none",
            alignItems: "center",
          }}
          style={{ marginBottom: "10px" }}
        >
          {phoneStep === 2 && (
            <>
              <AssignmentTurnedInRoundedIcon
                fontSize="large"
                style={{ color: "rgb(255, 94, 67)", marginRight: 8 }}
              />
              <Typography
                variant="h6"
                sx={{
                  fontWeight: "bold",
                  mb: 2,
                  display: "flex",
                  alignItems: "center",
                  fontFamily: "Prompt-Thin",
                }}
              >
                {/* <CheckCircleIcon sx={{ color: "#FF5E43", mr: 1 }} /> */}
                ยืนยันข้อมูล
              </Typography>
            </>
          )}
        </Box>
        {phoneStep === 1 ? (
          <ScrollableCardPhone
            phoneData={phoneData}
            setPhoneData={setPhoneData}
            listData={listData}
            inputData={inputData}
            setListData={setListData}
            mobilePhone={mobilePhone}
            dataPolicy={dataPolicy}
          />
        ) : phoneStep === 3 ? (
          <Box sx={{ p: 1, margin: "auto" }}>
            <Typography
              variant="h6"
              sx={{
                fontWeight: "bold",
                mb: 2,
                display: "flex",
                alignItems: "center",
                fontFamily: "Prompt-Thin",
              }}
            >
              <VerifiedUserIcon sx={{ color: "#FF5E43", mr: 1 }} />
              ยืนยัน OTP
            </Typography>

            <Paper
              elevation={0}
              sx={{
                border: "1px solid #e0e0e0",
                borderRadius: 3,
                p: 3,
                mb: 3,
                textAlign: "center",
              }}
            >
              <Typography sx={{ mb: 2, textAlign: "left" }}>
                กรุณาใส่หมายเลข OTP 6 หลัก
                <br />
                ที่ส่งไปยังเบอร์มือถือของท่าน
              </Typography>
              <input
                type="tel"
                inputMode="numeric"
                pattern="[0-9]*"
                placeholder="OTP"
                maxLength={6}
                value={otp}
                onChange={(e) => {
                  const onlyNums = e.target.value.replace(/\D/g, "");
                  setOtp(onlyNums);
                }}
                style={{
                  padding: "10px 20px",
                  borderRadius: "30px",
                  border: "1px solid #ccc",
                  fontSize: 18,
                  width: "100%",
                  outline: "none",
                  marginBottom: 8,
                }}
              />
              <div
                style={{
                  flex: 1,
                  flexDirection: "column",
                  justifyContent: "start",
                  alignItems: "flex-start", // ✅ ให้ชิดซ้าย
                  width: "100%",
                  marginTop: 10,
                }}
              >
                <div
                  className="font-size-content-otp"
                  style={{ fontSize: "14px", textAlign: "left" }} // ✅ กันพลาดเพิ่ม textAlign ด้วย
                >
                  ส่งรหัสผ่านไปที่หมายเลข{" "}
                  {localStorage.getItem("mobile_tel")
                    ? localStorage
                        .getItem("mobile_tel")
                        .replace(/(\d{3})(\d{4})(\d{3})/, "$1xxxx$3")
                    : ""}
                </div>
                <div
                  className="font-size-content-otp"
                  style={{ fontSize: "14px", textAlign: "left" }}
                >
                  กรณีไม่ได้รับหรือเปลี่ยนหมายเลขโทรศัพท์มือถือ
                </div>
                <div
                  className="font-size-content-otp"
                  style={{ fontSize: "14px", textAlign: "left" }}
                >
                  กรุณา
                  <span
                    onClick={() => setOpenContactModal(true)}
                    style={{
                      color: "#FF5E43",
                      textDecoration: "underline",
                      cursor: "pointer",
                      fontWeight: "bold",
                    }}
                  >
                    ติดต่อฝ่ายลูกค้าสัมพันธ์
                  </span>
                </div>
              </div>

              <Typography
                sx={{
                  color: "#f2654e",
                  fontSize: 14,
                  mt: 1,
                  cursor: "pointer",
                  textAlign: "left",
                }}
                onClick={resendOtp}
              >
                ส่งรหัส OTP อีกครั้ง?
              </Typography>
            </Paper>
          </Box>
        ) : (
          <ScrollableCardInformation />
        )}

        <br />
        <section className="action-address">
          <Grid
            container
            spacing={2}
            justifyContent="center" // จัดตำแหน่งตรงกลางแนวนอน
            alignItems="center" // จัดตรงกลางแนวตั้ง
            sx={{ minHeight: "10vh" }} // ให้ Grid เต็มความสูงหน้าจอ
          >
            <Grid item xs={12} sm={6} md={2}>
              <button
                onClick={() => {
                  if (phoneStep === 1) {
                    // exit page or back step
                    navigate(-1);
                  } else if (phoneStep === 2) {
                    setPhoneStep(1);
                  } else if (phoneStep === 3) {
                    setPhoneStep(2);
                  } else {
                    setPhoneStep(1);
                  }
                }}
                className="btn-address-back w-100 p-2 bold"
              >
                ย้อนกลับ
              </button>
            </Grid>
            <Grid item xs={12} sm={6} md={2}>
              <button
                style={{ fontSize: 18 }}
                onClick={() => {
                  if (phoneStep === 1) {
                    let errorsPhone = validatePhone();
                    if (errorsPhone === false) {
                      if (listData === undefined) {
                        // setOpenErrorMissingPhone(true);

                        setToggleImg(false);
                        setTextModal(
                          "กรุณาเลือกกรมธรรม์ที่ต้องการแจ้งเปลี่ยนเบอร์โทรศัพท์"
                        );
                        setCompletedModal(true);
                        refCarousel.current.scrollIntoView();
                      } else {
                        // console.log("select phoine data", selectedPhone);
                        setPhoneStep(2);
                      }
                    }
                  } else if (phoneStep === 2) {
                    handleReqOtp();
                    setPhoneStep(3);
                  } else {
                    savePhone();
                  }
                }}
                className="btn-address-next w-100 p-2 bold"
              >
                {phoneStep === 1 || phoneStep === 2 ? "ต่อไป" : "บันทึก"}
              </button>
            </Grid>
          </Grid>
        </section>
      </div>
      <Modal
        isOpen={openModal}
        onRequestClose={handleCloseModal}
        contentLabel="ModalPolicy"
        className="Modal"
        overlayClassName="Overlay"
      >
        <div className="p-lg-2 p-3">
          <h3 style={{ color: "#FA0E0E", fontSize: "18px" }}>กรมธรรม์เลขที่</h3>
          <div className="d-grid mb-4">
            <TextField
              type="text"
              size="small"
              onChange={(e) => handleSearchBasePolicy(e.target.value)}
              className=""
              value={searchBasePolicy}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <img src={iconSearch} height={20} width={20} alt="" />
                  </InputAdornment>
                ),
              }}
              sx={{
                backgroundColor: "#FFF",
                "& .MuiOutlinedInput-root": {
                  borderRadius: "6px",
                  height: "35px",
                  "& fieldset": {
                    borderColor: "#FB5E3F",
                  },
                  "&:hover fieldset": {
                    borderColor: "#FB5E3F",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#FB5E3F",
                  },
                },
              }}
            />
          </div>
          <div
            style={{
              maxHeight: "150px",
              overflowY: "auto",
              overflowX: "hidden",
            }}
          >
            {!filteredOptions.length == 0 ? (
              filteredOptions.map(renderOptionRow)
            ) : (
              <div className="text-center text-muted">
                ไม่มีข้อมูลที่ตรงกับการค้นหา
              </div>
            )}
          </div>
          <Row className="d-flex flex-row justify-content-evenly mt-3">
            {/* <Col className="bg-danger"> */}
            <button
              style={{ fontSize: 15 }}
              onClick={handleConfrimSearch}
              className="btn-checkout-premium w-25 p-2 bold"
            >
              ตกลง
            </button>
            <button
              style={{ fontSize: 15 }}
              onClick={handleCloseModal}
              className="btn-checkout-back w-25 p-2 bold"
            >
              ยกเลิก
            </button>
          </Row>
        </div>
      </Modal>
      <BootstrapModal
        show={completedModal}
        backdrop="static"
        // size="md"
        // style={{}}
        className="backdrop-alert"
        contentClassName="modal-alert"
      >
        <BootstrapModal.Body>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img
              src={toggleImg ? greenCheck : remove}
              alt="check-icon"
              className="modal-image-size"
            />
          </div>

          <li
            className="body-list-group"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Col
              xl={12}
              md={12}
              xs={12}
              style={{
                display: "flex",
                marginTop: 5,
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
              }}
            >
             <Typography sx={{ whiteSpace: "pre-line", textAlign: "center" }}>
                {textModal}
              </Typography>
            </Col>
          </li>
          <div className="d-flex justify-content-center flex-wrap">
            <button
              className="btn-checkout-modal w-20 p-2 bold"
              onClick={() => {
                if (toggleImg) {
                  navigate("/personal");
                } else {
                  setCompletedModal(false);
                }
              }}
            >
              กลับ
            </button>
          </div>
        </BootstrapModal.Body>
      </BootstrapModal>
      <ContactModal
        open={openContactModal}
        onClose={() => setOpenContactModal(false)}
      />
    </div>
  );
};

export default EditPhone2;
